// Przełącznik motywu jasny/ciemny. Domyślnie idziemy za systemem
// (brak data-theme), jawny wybór zapisujemy w localStorage i stawiamy
// na <html> — inline script w <head> odtwarza go przed pierwszym malowaniem.

const KEY = "fs_brief_theme";

function systemDark() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function isDark() {
    const set = document.documentElement.getAttribute("data-theme");
    return set ? set === "dark" : systemDark();
}

function paint(button) {
    const dark = isDark();
    button.querySelectorAll("[data-theme-icon]").forEach((icon) => {
        icon.hidden = icon.dataset.themeIcon !== (dark ? "dark" : "light");
    });
    button.setAttribute(
        "aria-label",
        dark ? "Przełącz na motyw jasny" : "Przełącz na motyw ciemny"
    );
}

export function initTheme() {
    const button = document.querySelector("[data-theme-toggle]");
    if (!button) return;

    paint(button);

    button.addEventListener("click", () => {
        const next = isDark() ? "light" : "dark";
        document.documentElement.setAttribute("data-theme", next);
        try {
            localStorage.setItem(KEY, next);
        } catch {
            /* prywatny tryb — motyw zadziała do przeładowania */
        }
        paint(button);
    });

    // dopóki nie ma jawnego wyboru, idziemy za systemem
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
        if (!document.documentElement.hasAttribute("data-theme")) paint(button);
    });
}
